import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconInsuranceCheck = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 79.497841 94.6642">
    <path fill={theme.palette.primary[150]} d="m79.498 17.215v26.447c0 24.086-16.376 45.088-39.768 51.002-23.354-5.894-39.73-26.916-39.73-51.001v-26.447c18.389-2.07 28.805-9.0573 39.749-17.216 10.944 8.1587 21.36 15.146 39.749 17.215" />
    <path fill={theme.palette.primary[500]} d="m10.053 43.565v-17.763c12.385-2.6703 21.483-7.6046 29.74-13.235 8.4328 5.7857 17.355 10.623 29.74 13.255v17.763c0 18.479-12.111 34.656-29.74 40.19-17.629-5.536-29.74-21.712-29.74-40.21z" />
    <path fill={theme.palette.common.white} d="m32.159 60.609-5.7292-5.6655c-1.3295-1.3148-1.3415-3.4584-0.02673-4.7879 0.0073-0.0074 0.01461-0.01471 0.02197-0.02201 1.3435-1.3339 3.5103-1.3382 4.8592-0.0097l2.2817 2.2472 15.159-14.974c1.3445-1.3281 3.5072-1.3275 4.851 0.0013 1.3249 1.3102 1.3368 3.4463 0.02664 4.7712-0.0085 0.0086-0.01703 0.01713-0.02562 0.02563l-18.604 18.413c-0.77911 0.77112-2.0338 0.77138-2.8132 0.000599z" />
  </SvgIcon>
);

IconInsuranceCheck.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        150: PropTypes.string.isRequired,
        500: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconInsuranceCheck);



// WEBPACK FOOTER //
// ./src/components/icons/IconInsuranceCheck.js